import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '@/types';

interface AuthStore {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  /**
   * True, solange der AuthProvider die Anmeldung noch ermittelt.
   *
   * Bewusst nicht persistiert: Nach einem Reload ist der Zustand wieder offen,
   * bis der Vario-Handshake und Supabases erstes Auth-Event durch sind. Guards
   * duerfen in dieser Zeit nicht auf /login umleiten, sonst fliegt raus, wer
   * eine gueltige Session hat, deren Laden nur noch laeuft.
   */
  isInitializing: boolean;
  login: (user: User, token: string) => void;
  logout: () => void;
  updateUser: (user: User) => void;
  setInitialized: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isInitializing: true,

      login: (user: User, token: string) => {
        localStorage.setItem('authToken', token);
        set({ user, token, isAuthenticated: true });
      },

      logout: () => {
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('impersonation');
        set({ user: null, token: null, isAuthenticated: false });
      },

      updateUser: (user: User) => {
        set({ user });
      },

      setInitialized: () => {
        set({ isInitializing: false });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
